import React from "react";
import {FormattedMessage} from "react-intl";
import logoFooter from "./../../../../app/assets/images/logo-footer-001-300x123.png";
import logoCodeciping from "./../../../../app/assets/images/codeciping_eur.png";
import './scss/code.scss';

const FooterCode = () => {
  return (
    <div
      className={`footer py-4 d-flex flex-lg-column`}
      id="kt_footer"
    >
      <div className={`d-flex flex-column flex-md-row align-items-start`}>
        <div className="text-white order-md-1 footer-block">
          <div className="footer-block-header">
            <FormattedMessage id="CODE.FOOTER.1.HEADER" />
          </div>

          <img src={logoFooter} className="logo-iceland" />

          <p className="p-top">
            <a href={'/privacy'} target={'_blank'} className="text-white">
              <FormattedMessage id="CODE.POLICY_POLICY" />
            </a>
          </p>
        </div>

        <div className="text-white order-md-2 footer-block">
          <div className="footer-block-header">
            <FormattedMessage id="CODE.FOOTER.2.HEADER" />
          </div>

          <p className="p-top">
            <FormattedMessage id="CODE.FOOTER.2.PROMO" />
          </p>

          <a href={'https://code-europe.onesource.pt/en/project'} target={'_blank'}>
            <img src={logoCodeciping} className="logo-codeciping" />
          </a>
        </div>

        <div className="text-white order-md-3 footer-block">
          <div className="footer-block-header">
            <FormattedMessage id="CODE.FOOTER.3.HEADER" />
          </div>

          <p className="p-top">
            Elisa Lironi, ECAS,
            <br/>
            <a href={'mailto:elisa.lironi@codecidingeurope.eu'} className="text-white link-email">
              elisa.lironi@codecidingeurope.eu
            </a>
          </p>

        </div>

      </div>
    </div>
  );
};

export default FooterCode;
